import { LABELMONTH, DAY_MONTH_YEAR, DATE_NUMBER_SLASH } from '@/libs/filterDate'
import { today } from '@/store/helpers'

/**
 * Formats a date to "7 Jan 2025" format
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string (e.g., "7 Jan 2025")
 */
const formatShortDate = date => {
  const day = date.getDate()
  const month = LABELMONTH[date.getMonth()]
  const year = date.getFullYear()
  return `${day} ${month} ${year}`
}

/**
 * Formats a date range into a readable string
 * @param {string|Date} startDate - The start date of the range
 * @param {string|Date} endDate - The end date of the range
 * @returns {string} Formatted date range string:
 *   - "Bulan Ini" if the range is the current month
 *   - Month and year if the range is a full month
 *   - Start date - End date otherwise
 */
// eslint-disable-next-line import/prefer-default-export
export function getFormattedDateRange(startDate, endDate) {
  if (!startDate || !endDate) {
    return 'Tentukan Tanggal'
  }

  const start = new Date(startDate)
  const end = new Date(endDate)

  if (
    start.getDate() === 1
    && end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()
  ) {
    if (
      start.getMonth() === today.getMonth()
      && start.getFullYear() === today.getFullYear()
    ) {
      return 'Bulan Ini'
    }
    return `${LABELMONTH[start.getMonth()]} ${start.getFullYear()}`
  }
  return `${DAY_MONTH_YEAR(start)} - ${DAY_MONTH_YEAR(end)}`
}

/**
 * Formats a date range into a concise string without "Bulan Ini"
 * @param {string|Date} startDate - The start date of the range
 * @param {string|Date} endDate - The end date of the range
 * @returns {string} Formatted date range string:
 *   - Short month and year if the range is a full month (e.g., "Jan 2024")
 *   - Start date - End date otherwise
 */
export function getShortFormattedDateRange(startDate, endDate) {
  if (!startDate || !endDate) {
    return 'Tentukan Tanggal'
  }
  const start = new Date(startDate)
  const end = new Date(endDate)

  if (
    start.getDate() === 1
    && end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()
  ) {
    return `${LABELMONTH[start.getMonth()]} ${start.getFullYear()}`
  }
  return `${formatShortDate(start)} - ${formatShortDate(end)}`
}
